import { render, staticRenderFns } from "./PartesTransportes.vue?vue&type=template&id=16ff6116&scoped=true&"
import script from "./PartesTransportes.vue?vue&type=script&lang=js&"
export * from "./PartesTransportes.vue?vue&type=script&lang=js&"
import style0 from "./PartesTransportes.vue?vue&type=style&index=0&id=16ff6116&lang=scss&scoped=true&"
import style1 from "./PartesTransportes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ff6116",
  null
  
)

export default component.exports